document.addEventListener("DOMContentLoaded", () => {
  iniciarApp();
});

function iniciarApp() {
    const productPage = document.querySelector(".product");
    let wloBlockCounter = 0;

    /*
    if (productPage !== null) {            
        const suscriptionBlock = setInterval(function() {	
          const suscriptionCheckboxs = document.querySelectorAll(".sls-option-container.seal-table");
          if (suscriptionCheckboxs.length) {
            suscriptionCheckboxs.forEach((suscriptionCheckbox) => {
                  suscriptionCheckbox.addEventListener("click", function (e) {
                      changePriceInLabel(e);
                  }); 
             });
             clearInterval(suscriptionBlock);
          }
      
            if (wloBlockCounter == 20) {
    			clearInterval(suscriptionBlock);
    		} else {
    			wloBlockCounter = wloBlockCounter + 1;
    		}
      }, 100);     
    }
  */

  //Limpiar formulario registro newsletter eventos
    const pageNewsletter = document.querySelector("#alta-newsletter");
	if (pageNewsletter !== null) {
        const newsBlock = setInterval(function() {	
          const enviar = document.querySelector("button[name='submit']");
          
          if (enviar) {
  			clearInterval(newsBlock);				
            const nombre = document.querySelector("input[name='texto']");
        	const email = document.querySelector("input[name='email']");
            const consentimiento = document.querySelector("input[name='checkbox']");

            enviar.addEventListener("click", () => {         
                if (nombre && email && consentimiento.checked) {
                  setTimeout(() => {
                      nombre.value = '';
                      email.value = '';
                      consentimiento.checked = false;
                  }, 3000);
                }
            });   
  		  } 					
    	}, 100);
    }
}

function changePriceInLabel(input) {
  const inputSellingPlan = document.querySelector("input[name='selling_plan']");
  const discountLabel = document.querySelector(".samita_productLabel-content-text");

  if (input.target.parentElement.parentElement.parentElement.parentElement.classList.contains("sls-active")) {
      return;
  }
  
  if (inputSellingPlan.value) {    
    if (discountLabel.hasAttribute("discount")) {
      discountLabel.textContent =  discountLabel.getAttribute("discount");
    
    } else {
      discountLabel.setAttribute("discount", discountLabel.textContent);
    }
     
  } else {
    
      discountLabel.setAttribute("discount", discountLabel.textContent);
      discountLabel.textContent = '20%';
  }
}